// import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/style.css'
// 引入FontAwesome图标库
import '@fortawesome/fontawesome-free/css/all.css'
// 引入全局主题样式
import './assets/css/global-theme.css'
// 引入移动端优化样式
import './assets/css/mobile-optimizations.css'
// 引入性能监控
import { performanceMonitor, lazyLoader, preloadCriticalResources } from './utils/performance.js'
import {getRequest,postRequest} from "@/api/api";
import wxShare from './utils/wxShare'

Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.$toast = vant.Toast
Vue.prototype.$wxShare = wxShare


Vue.config.productionTip = false

// 预加载关键资源
preloadCriticalResources();

// 初始化懒加载
document.addEventListener('DOMContentLoaded', () => {
  lazyLoader.observeAll();
});

// 在开发环境下输出性能指标
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('load', () => {
    setTimeout(() => {
      console.log('性能指标:', performanceMonitor.getMetrics());
    }, 2000);
  });
}

// 注册全局 v-reveal 滚动显现动画指令
const revealObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        // 触发一次后取消观察，避免重复动画
        revealObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
);

Vue.directive('reveal', {
  inserted: function (el, binding) {
    el.classList.add('reveal-element');
    // 支持传递方向修饰符，例如 v-reveal="'left'"
    if (binding.value) {
      el.classList.add(`reveal-${binding.value}`);
    } else {
      el.classList.add('reveal-up'); // 默认向上浮现
    }
    revealObserver.observe(el);
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

vant.Toast.setDefaultOptions({position:'bottom'})